module.exports = __webpack_public_path__ + "static/media/play.d0529e5e.png";